import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { EventGQL, fetchSeasonEvents } from '../../Api'
import { EventBox } from '../../Components/GameTicker/EventBox/EventBox'
import { Box } from '../../Components/Layout'
import { CURRENT_YEAR } from '../../Config/League/league.config'
import { AcademyWeekendEvent } from './AcademyWeekendEvent'
import { getShortMarket } from '../../Utils'
import { CardSwiper } from '../../Components/CardSwiper'

const MarketPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const location = useLocation()
  const pathEnd = location.pathname.split('/').pop()
  const slug = pathEnd?.split('?')[0]
  const [events, setEvents] = useState<EventGQL[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const getEvents = async () => {
      const events = await fetchSeasonEvents(CURRENT_YEAR, false)
      if (events && events.length > 0) {
        let filteredEvents = filterEvents(events)
        setEvents(filteredEvents)
      }
      setLoading(false)
    }
    getEvents()
  }, [])

  const filterEvents = (events: EventGQL[]) => {
    if (slug) {
      return events.filter(
        (event) => event.location && getShortMarket(event) === slug
      )
    }
    return []
  }

  const items = useMemo(() => {
    return events.map((ev) => <EventBox key={ev.id} eventData={ev} />)
  }, [events])


  return (
    <>
    <Box vertMargins={2}>
      {!loading && events.length > 0 ? (
         <CardSwiper
         items={items}
         cardSize="ticker"
         idx={'0'}
         showPagination={false}
       />
      ) : (
        <div>No events released yet.</div>
      )}
    </Box>
      {slug && <AcademyWeekendEvent market={slug} />}
      </>
  )
}

export default MarketPage
